import { render, staticRenderFns } from "./WarningReport.vue?vue&type=template&id=008ee984&"
import script from "./WarningReport.vue?vue&type=script&lang=js&"
export * from "./WarningReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports